<template>
  <div
    class="notifications-container"
    v-if="notificationsPage && notificationsPage.content"
  >

    <div
      class="notification-card"
      v-for="(notification) in notificationsPage.content"
      :key="notification.id"
    >

      <div class="notification-card-title">
        <h2> №{{ notification.id }} </h2>
        <span
          class="notification-card-subject"
          :class="getSubjectClass(notification.subject)"
        >{{ notification.subject }}</span>
      </div>

      <div class="notification-card-details">
        <div class="notification-card-details-item">
          {{ notification.message }}
        </div>

        <div class="notification-card-details-item">
          Дата :
          {{ getDateFormat((notification.timestampInEpochMilli / 1000) < 1000000000000 ? notification.timestampInEpochMilli : notification.timestampInEpochMilli / 1000) }}
        </div>
      </div>

    </div>

    <div class="paging-bottom">
      <Paging
        :refresh="loadNotificationsPage"
        :per-page="perPage"
        :data.sync="notificationsPage"
        :pagingClass="'bottom'"
      />
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VisCommon from '../components/VisCommon'
import Paging from '../components/Paging'

const BILLING_API = 'billing/notifications'
export default {

  name: 'BillingNotifications',
  extends: VisCommon,
  components: {
    Paging
  },

  data() {
    return {
      loading: false,
      notificationsPage: {content: []},
      currentSort: 'timestampInEpochMilli',
      currentSortDir: 'desc',
      perPage: 8
    }
  },

  created: function () {
    this.loadNotificationsPage()
  },

  computed: {
    ...mapGetters([
      'authenticationToken',
      'clientId'
    ])
  },

  methods: {
    prepareSecurityHeader() {
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },

    loadNotificationsPage(page) {
      let that = this
      this.loading = true
      page = page ? (page - 1) : 0
      let url = BILLING_API + '/get' + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          console.log(response.data.response)
          that.notificationsPage = response.data.response
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки уведомлений. ')
        })
    },

    getSubjectClass: function (subject) {
      if (subject === 'REPLENISH_BALANCE') {
        return 'subject-info'
      } else if (subject === 'STOPPED_CAMPAIGN_RESUMED_AFTER_REPLENISH_BALANCE') {
        return 'subject-info'
      } else if (subject === 'CREDIT_LIMIT_UPDATE') {
        return 'subject-info'
      } else if (subject === 'DETAILS_REPORT_SUCCESS') {
        return 'subject-info'
      } else if (subject === 'CAMPAIGN_STOPPED_ON_CREDIT_LIMIT_EXCEED') {
        return 'subject-warn'
      }
    }
  }

}
</script>

<style lang="css" scoped>
.notifications-container {
  margin-top: 5rem;
  max-width: 100%;
  padding: 0 2rem;
  /* margin: auto; */
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-items: center;
  text-align: center;
}

.notification-card {
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  min-height: 10rem;
  margin-bottom: 2rem;
}

.notification-card-title {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
}

.notification-card-title h2 {
  text-align: left;
  font-weight: 600;
}

.notification-card-subject {
  margin-right: 0.5rem;
  padding-top: 3px;
  font-size: 0.8rem;
  min-height: 20px;
  min-width: 200px;
  border-radius: 20px;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
}

.subject-info {
  background-color: #a2e1f6;
}

.subject-warn {
  background-color: #fac7d3;
}

.notification-card-details {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.notification-card-details-item {
  margin-bottom: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// BillingNotifications.vue?b184a76c